const lightning_config_store = {
    subscribers:{},
    options:{
        active: false,
        tooltipOptions: {show:false}
    },
    setOption(option, value){
        this.options[option] = value
        this.publish('SET_OPTION', {option: option, value:value})
    },
    getOption(option){
        return this.options[option]
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default lightning_config_store